<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div class="product_bg"></div>
    <div class="product_con">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span @click="() => { this.$router.go(-1) }" class="goback">返回</span></el-breadcrumb-item>
        <el-breadcrumb-item>影像云</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="con_tit fontsize2">影像云</div>
      <p class="fontsize1">
        <span class="con_text">简介：</span><br>
        随着医学科学技术和电子信息技术的发展，医学影像技术设备高速发展。
        医学影像检查诊断应用范围越来越广，充当着医疗健康“侦察兵”的角色，在疾病诊断治疗中举足轻重，
        不可或缺，发挥着越来越重要的作用。在我省山区面积大，县乡镇分散、交通运距长，
        医疗资源不足，医师人才缺乏的省情背景下，运用互联网、大数据信息技术，
        建立区域性（全省）医学影像平台，构建全省上下各级医疗机构的医学影像网络系统，
        对于推广远程医疗服务，优化医疗资源配置，实现医疗资源下沉，提高医疗服务整体能力和水平，促进基层医疗卫生服务均等化，
        解决看病就医难题，推进分级诊疗制度建立，实现医疗改革和健康中国建设的目标，具有重大而紧迫的现实意义。<br><br>
      </p>
      <div class="con_img"><img src="../../assets/img/Product8s.png" /></div>
    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {

    }
  },
  mounted () {
    if (document && document.body) {
      document.body.style.margin = '0px';
      this.originalBodyMargin = document.body.style.margin;
    }
  },
  beforeDestroy () {
    if (document && document.body) {
      document.body.style.margin = this.originalBodyMargin || '';
    }
  }
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.goback:hover {
  cursor: pointer;
  color: #409EFF;
}

.bottom {
  height: 70px;
}

.product_bg {
  background-image: url("../../assets/img/Product_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.product_con {
  width: 70%;
  margin: 0px auto 50px auto;
  padding: 20px;

  .con_tit {
    font-weight: 600;
    text-align: center;
    margin: 20px 0px;
  }

  .con_text {
    font-weight: 600;
  }

  .con_img {
    display: flex;
    justify-content: center;

    img {
      max-width: 40%;
      height: 100%;
    }

  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .product_bg {
    height: 30vh;
  }

  .fontsize1 {
    font-size: 15px;
  }

  .product_con {
    margin: auto;
    width: 90%;

    .con_img {
      img {
        max-width: 90%;
      }
    }
  }
}
</style>